<div *ngIf="alert && alert.message && alert.message.length > 0"
     class="footer-alert footer-alert-{{ alert.type }}">
  <strong>Message:</strong> {{ alert.message }}
</div>